import GenericCard from '../../../../components/GenericCards';
import { Col, Row } from 'react-bootstrap';
import IconButton from '../../../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Label from '../../../../components/Label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Blockquote from '../../../../components/Blockquote';
import Button from '../../../../components/Button';
import React from 'react';

export const CurrentElections = () => {
  const elections = [
    {
      title: 'Before-Tax',
      percent: 3,
    },
    {
      title: 'Roth 401(k)',
      percent: 1,
    },
    {
      title: 'Before-Tax Catch-Up',
      percent: 0,
    },
    {
      title: 'Roth 401(k) Catch-Up',
      percent: 0,
    },
    {
      title: 'After-Tax',
      percent: 0,
    },
  ];
  return (
    <GenericCard variant={'white'} className="">
      <Row>
        <Col className={'col-12 mb-10'}>
          <Row className="align-items-center">
            <Col classNam={'col-8'}>
              <h5>Current Elections</h5>
            </Col>
            <Col className={'col-2'}>
              <IconButton
                variant="icon-emphasized"
                icon={light('question-circle')}
                color={'primary'}
              />
            </Col>
            <Col className={'col-2'}>
              <IconButton variant="icon-default" icon={light('ellipsis')} />
            </Col>
          </Row>
        </Col>
        <Col className={'col-12'}>
          <Row>
            <Col>
              {elections.map((election, index) => {
                return (
                  <Row
                    className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom "
                    key={index}
                  >
                    <Col className="col-8 ps-0 ">{election.title}</Col>

                    <Col className="col-4 text-end pe-0">
                      {election.percent}%
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3  container-light-grey gray-nested-background ">
            <Col className="pt-1 ps-0 col-8 fw-bold">Total</Col>
            <Col className="col-4 text-end pe-0 fw-bold">4%</Col>
          </Row>
        </Col>

        <Col className={'col-12 mt-5 mb-5'}>
          <Row className={'pe-1 mt-5'}>
            <Col className={'col-8 m-0 p-0'}>
              <span className="text-dark-gray-50 lh-xs text-fs-6">
                Company Match
              </span>
              <FontAwesomeIcon
                icon={light('info-circle')}
                className={'ms-2 text-dark-gray-50 lh-xs text-fs-6'}
              />
            </Col>
            <Col className={'col-4 text-end m-0 p-0'}>
              <span className="lh-xs text-fs-6">
                Partial Match
              </span>
            </Col>
          </Row>
          <Row className={'pe-1 mt-5 border-top'}>
            
          </Row>
          <Row className={'pe-1 mt-5'}>
            <Col className={'col-8 m-0 p-0'}>
              <span className="text-dark-gray-50 lh-xs text-fs-6">Auto-Increase</span>
            </Col>
            <Col className={'col-4 text-end m-0 p-0'}>
              <span className="lh-xs text-fs-6">Not enrolled</span>
            </Col>
          </Row>
        </Col>
        <Col className={'mt-5'}>
          <Blockquote>
            <span className="text-dark-gray fw-bold">Did you know?</span>
            <ul className="text-dark-gray">
              <li>
                You're missing the company match and leaving free money on the
                table.
              </li>
              <li>
                Increasing your contribution to 6% will earn you an additional
                $600.
              </li>
            </ul>
          </Blockquote>
        </Col>
        <Col className={'col-12 mt-8 text-end'}>
          <Button color={'blue'}>Change Contributions</Button>
        </Col>
      </Row>
    </GenericCard>
  );
};
